import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import useTelemetry from '@/providers/TelemetryProvider/useTelemetry';
import { mixpanelEvents } from '@/constants/mixpanel';
import { TCustomAxiosError } from '@/services/api';
import queryKeys from '@/constants/queryKeys';
import { downgradePeerSupportToMemberPost } from '@/services/api/requests/peer-support';

const useDowngradePeerSupportToMember = (onSuccessCallback?: () => void) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { trackEvent } = useTelemetry();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ organizationId, userId }: { organizationId: string; userId: string }) => {
      const response = await downgradePeerSupportToMemberPost(organizationId, userId);

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.organization.members] });

      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Successfully downgraded Peer Support to Member!',
      });

      trackEvent(mixpanelEvents.DOWNGRADE_PEER_SUPPORT_TO_MEMBER);

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: 'Error while downgrading Peer Support to Member',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default useDowngradePeerSupportToMember;
